import React, { useState } from "react";

import noitems from "../svg x gifs/Empty.gif";
import loading from "./Fast loading.gif";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
function Cart({
  setactive,
  cart,
  handleUpdateCartQty,
  handleRemoveFromCart,
  HandleEmptyCard,
}) {
  const [coupon, setcoupon] = useState(false);
  function Coupon() {
    setcoupon((prev) => !prev);
  }
  function Emptycart() {
    return (
      <div className="flex justify-center text-center flex-col mt-[200px]">
        <div className="flex justify-center font-bold1  font-medium text-2xl">
          <h1>You have no items in your Cart!</h1>
        </div>
        <div className="flex justify-center items-center">
          <img src={noitems} alt="" />
        </div>
        <h1 className="flex justify-center">
          Redirected to{"  "}
          <Link onClick={() => setactive(0)} to="/">
            <a className="border-b-2  ml-2 border-primary-100 text-primary-100">
              {" "}
              Home
            </a>
          </Link>
        </h1>
      </div>
    );
  }
  function Filledcart() {
    return (
      <div className=" pt-[100px]">
        <div className="my-[70px] flex justify-center font-bold1 font-bold text-4xl">
          <h1>Your Cart</h1>
        </div>
        <div className="container mt-4 ">
          <div className="flex  demitablet:flex-col  my-6">
            <div className="w-3/4 tablet:w-[100%] shadow-md px-10 demitablet:px-0 ">
              <div className="flex  font-font2  mb-6 py-[30px] border-b-[1px] border-gray-200">
                <h3 className=" font-medium text-gray-600  pr-32 text-[13px]  uppercase tablet:w-2/5 phone:w-3/5 w-2/5 text-left">
                  Products Details
                </h3>
                <h3 className=" font-medium text-gray-600 text-center text-[13px] uppercase tablet:w-1/5 w-1/5 ">
                  Quantity
                </h3>
                <h3 className=" font-medium phone:hidden text-gray-600 text-center text-[13px] uppercase tablet:w-1/5 w-1/5 ">
                  Price
                </h3>
                <h3 className=" font-medium text-gray-600 text-center text-[13px] uppercase tablet:w-1/5 w-1/5 ">
                  Total
                </h3>
              </div>
              <div>
                {cart.line_items.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center hover:bg-gray-100 rounded-lg "
                  >
                    <div className="flex w-2/5 tablet:w-2/5 phone:w-3/5  my-1 items-center ">
                      <img
                        className="h-[80px] md:h-[150px] md:flex-initial  object-cover"
                        src={item.image.url}
                        alt={item.name}
                      />
                      <div className="flex flex-col pl-2 font-bold1 justify-between">
                        <h1 className="uppercase text-[14px] md:text-xl text-bold font-medium">
                          {item.name}
                        </h1>
                        <p className="text-[14px] md:text-xl">
                          {item.quantity} * 250ml
                        </p>
                        <div
                          onClick={() => handleRemoveFromCart(item.id)}
                          className="text-[12px] md:text-xl cursor-pointer hover:text-red-500 text-gray-400 pt-4"
                        >
                          Remove
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center w-1/5 tablet:w-1/5 ">
                      <div className="flex phonex2:flex-col phonex2:justify-center phonex2:items-center phonex2:space-x-0 phonex2:space-y-1 space-x-5 phone:mb-4 items-center">
                        <button
                          onClick={() =>
                            handleUpdateCartQty(item.id, item.quantity - 1)
                          }
                          className="w-[21px] h-[21px] group-hover:bg-white group-hover:text-primary-100 flex justify-center rounded-full text-white items-center bg-primary-100"
                        >
                          -
                        </button>
                        <button className="text-[14px] md:text-xl font-bold2">
                          {" "}
                          {item.quantity}
                        </button>
                        <button
                          onClick={() =>
                            handleUpdateCartQty(item.id, item.quantity + 1)
                          }
                          className="w-[21px] h-[21px]  group-hover:bg-white group-hover:text-primary-100 flex justify-center rounded-full text-white items-center bg-primary-100"
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="flex phone:hidden justify-center w-1/5  font-bold2 text-[14px] md:text-xl">
                      {item.price.formatted_with_symbol}
                    </div>
                    <div className="flex justify-center w-1/5  font-bold2 text-[14px] md:text-xl">
                      {item.line_total.formatted_with_symbol}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-gray-200 shadow-md w-1/4 demitablet:w-[100%] h-fit ">
              <div className="py-6 font-bold1 px-10 font-medium text-gray-900 border-b-[1px] border-white text-xl ">
                <h1>order summary</h1>
              </div>

              <div className="flex flex-col px-10 space-y-4 justify-between py-6">
                <div className="flex justify-between">
                  <h2>subtotal:</h2>

                  <span>{cart.subtotal.formatted_with_symbol}</span>
                </div>
                <div className="flex  justify-between">
                  <h2>Shipping:</h2>
                  <span>free</span>
                </div>
                <div
                  onClick={Coupon}
                  className="flex  cursor-pointer space-x-4 justify-start items-center text-primary-200"
                >
                  <h2>Add coupon code</h2>
                  <FiArrowRight />
                </div>
                {coupon && (
                  <div className="">
                    <input
                      className="h-12 w-full px-4   outline-none"
                      placeholder="your coupon..."
                      type="text"
                      value="Not Available"
                      name=""
                      id=""
                    />
                  </div>
                )}
              </div>
              <div className="py-6 px-10 flex justify-between font-bold1 font-medium text-gray-900 border-white border-t-[1px] text-xl ">
                <h1>Total:</h1>
                <span>{cart.subtotal.formatted_with_symbol}</span>
              </div>
              <Link to="/checkout">
                <div className="cursor-pointer flex hover:bg-primary-200 duration-300 justify-center text-white font-bold1 text-xl bg-primary-100 w-full">
                  <button className="py-4 px-20 ">Checkout</button>
                </div>
              </Link>
              {/* <div>
                <button
                  className="bg-red-500 w-full py-4 px-20 text-white"
                  onClick={HandleEmptyCard}
                >
                  empty
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (!cart.line_items)
    return (
      <div className="flex justify-center items-center">
        <img src={loading} alt="" />
      </div>
    );
  return <>{cart.line_items.length === 0 ? <Emptycart /> : <Filledcart />}</>;
}

export default Cart;
